var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilOutlineMemory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-outline"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EBF2FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6855 8.9C12.237 8.9 11.8177 9.12278 11.5667 9.4945L10.1312 11.6203C9.98051 11.8435 9.9 12.1066 9.9 12.3758V17.75C9.9 18.4956 10.5044 19.1 11.25 19.1H16.7662C17.5118 19.1 18.1162 18.4956 18.1162 17.75V10.25C18.1162 9.50442 17.5118 8.9 16.7662 8.9H12.6855ZM10.8208 8.99083C11.2392 8.3713 11.938 8 12.6855 8H16.7662C18.0088 8 19.0162 9.00736 19.0162 10.25V17.75C19.0162 18.9927 18.0088 20 16.7662 20H11.25C10.0074 20 9 18.9927 9 17.75V12.3758C9 11.9271 9.13419 11.4886 9.38533 11.1167L10.8208 8.99083Z",
    fill: "#3C7AF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3414 9.76685C14.5899 9.76685 14.7914 9.96832 14.7914 10.2168V11.7829C14.7914 12.0314 14.5899 12.2329 14.3414 12.2329C14.0929 12.2329 13.8914 12.0314 13.8914 11.7829V10.2168C13.8914 9.96832 14.0929 9.76685 14.3414 9.76685ZM16.4083 9.76685C16.6568 9.76685 16.8583 9.96832 16.8583 10.2168V11.7829C16.8583 12.0314 16.6568 12.2329 16.4083 12.2329C16.1597 12.2329 15.9583 12.0314 15.9583 11.7829V10.2168C15.9583 9.96832 16.1597 9.76685 16.4083 9.76685ZM12.2744 10.355C12.523 10.355 12.7244 10.5565 12.7244 10.805V11.7829C12.7244 12.0314 12.523 12.2329 12.2744 12.2329C12.0259 12.2329 11.8245 12.0314 11.8245 11.7829V10.805C11.8245 10.5565 12.0259 10.355 12.2744 10.355Z",
    fill: "#3C7AF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6024 15.2755V17.2872H16.4138V15.2755H11.6024ZM10.7024 15.1255C10.7024 14.7112 11.0382 14.3755 11.4524 14.3755H16.5638C16.978 14.3755 17.3138 14.7112 17.3138 15.1255V17.4372C17.3138 17.8514 16.978 18.1872 16.5638 18.1872H11.4524C11.0382 18.1872 10.7024 17.8513 10.7024 17.4372V15.1255Z",
    fill: "#3C7AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutlineMemory);
export default __webpack_public_path__ + "static/media/pencil-outline-memory.fa99d8aacd55a2cf3dc5490e9597a508.svg";
export { ForwardRef as ReactComponent };